import React from "react";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import Button from "storybookComponents/Button";
import StyledTable from "components/StyledTable";
import Modal from "components/Modal";
import { BinIcon } from "icons";
import "../assets/styles.css";
import { compare } from "content/utils/commonParsing.js";

const BrokerList = ({ classes, data, onArchive, event }) => {
  const [rows, setRows] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedId, setSelectedId] = React.useState(null);

  const handleSort = (field, order) => {
    let sortedData = data.slice().sort((a, b) => {
      return compare(a[field], b[field], !order);
    });
    setRows(getRows(sortedData));
  };

  const handleBinClick = (id) => {
    setSelectedId(id);
    setOpenModal(true);
  };

  const getRows = (d) => {
    return d.map((item) => {
      return {
        importedAt: (
          <Typography className={classes.tableText} noWrap>
            {moment(item.importedAt).format("D MMM YYYY, h:mmA")}
          </Typography>
        ),
        fileName: (
          <Typography className={classes.tableText} noWrap>
            {item.fileName}
          </Typography>
        ),
        importedBy: (
          <Typography className={classes.tableText} noWrap>
            {item.importedBy}
          </Typography>
        ),
        contactsBeforeLoad: (
          <div className={classes.tableText}>
            <span className={classes.leftBox}>{item.contactsAfterLoad || "--"}</span>
            <span className={classes.leftMargin}>{item.contactsBeforeLoad || "--"}</span>
          </div>
        ),
        successCount: (
          <Typography className={classes.tableText}>{item.successCount || "--"}</Typography>
        ),
        failureCount: (
          <Typography className={classes.tableText}>{item.failureCount || "--"}</Typography>
        ),
        action: (
          <div className="action-icon">
            <BinIcon
              viewBox="0 0 24 24"
              className={classes.binIcon}
              onClick={() => handleBinClick(item.id)}
            />
          </div>
        ),
      };
    });
  };

  const columns = [
    {
      field: "importedAt",
      fieldName: "Uploaded Time",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
    },
    {
      field: "fileName",
      fieldName: "File Name",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
    },
    {
      field: "importedBy",
      fieldName: "Uploaded By",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
    },
    {
      field: "contactsBeforeLoad",
      fieldName: "# Contacts After & Before",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
    },
    {
      field: "successCount",
      fieldName: "# Success",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
    },
    {
      field: "failureCount",
      fieldName: "# Failure",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
    },
    {
      field: "action",
      fieldName: "",
      align: "center",
      width: 72,
      cellClassName: classes.tableCell,
      className: classes.tableHeader,
    },
  ];

  const handleCloseModal = () => setOpenModal(false);

  const handleArchive = () => {
    setOpenModal(false);
    onArchive(selectedId);
  };

  const renderModalActions = () => (
    <>
      <Button color="darkBlack" variant="tertiary" size="md" onClick={handleCloseModal}>
        Cancel
      </Button>
      <Button type="submit" variant="secondary-negative" size="md" onClick={handleArchive}>
        Delete
      </Button>
    </>
  );

  React.useEffect(() => {
    handleSort("importedAt", true);
    //if (!!data) setRows(getRows(data));
  }, [data]);

  return (
    <div className={classes.brokerTopMargin}>
      <div className={classes.text3}>{event ? "CSV Upload Log" : "Broker Upload Log"}</div>
      <div className={classes.tableContainer}>
        <StyledTable
          columns={columns}
          rows={rows}
          sortHandler={handleSort}
          showFilter={false}
          defaultSortBy="importedAt"
          className={classes.table}
        />
      </div>

      {!!selectedId && (
        <Modal
          title="Confirm Delete"
          open={openModal}
          handleClose={handleCloseModal}
          actionChildren={renderModalActions()}
        >
          <p>
            Are you sure you want to delete the log updated on{" "}
            <strong>
              {moment(data.filter((item) => item.id === selectedId)[0].importedAt).format(
                "MMM D YYYY, h:mm a"
              )}
            </strong>
            ?
          </p>
        </Modal>
      )}
    </div>
  );
};

export default BrokerList;
